import { defaultParamsSerializer, formatDates, handleApiResponse } from '@/functions';
import { useQuery } from '@tanstack/react-query';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IGetTransactionsParams, IGetTransactionsResponse } from '@/interfaces';

export const useRequestGetTransactions = (params?: IGetTransactionsParams) => {
	const { invalidate } = useInvalidateQueries();
	const { isFetching, data, error } = useQuery({
		queryKey: [routes.api.transactions, params],
		queryFn: ({ queryKey: [_url, _params] }) => {
			const { periodFrom, periodTo, ...rest } = _params as IGetTransactionsParams;
			const apiParams: any = { ...rest };
			if (periodFrom) apiParams['period[from]'] = periodFrom;
			if (periodTo) apiParams['period[to]'] = periodTo;

			return apiClient
				.get<IGetTransactionsResponse>(_url as string, apiParams, { paramsSerializer: defaultParamsSerializer })
				.then(handleApiResponse)
				.then(data => formatDates(data) as IGetTransactionsResponse);
		}
	});

	const transactions = data?.data ?? [];

	const refresh = () => invalidate(routes.api.transactions);

	return {
		data: data as IGetTransactionsResponse,
		isLoading: isFetching,
		transactions,
		refresh,
		error
	};
};
